import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M12 22.0002C17.5228 22.0002 22 17.5231 22 12.0002C22 6.4774 17.5228 2.00024 12 2.00024C6.47715 2.00024 2 6.4774 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002ZM12 9.00024C12.5523 9.00024 13 8.55253 13 8.00024C13 7.44796 12.5523 7.00024 12 7.00024C11.4477 7.00024 11 7.44796 11 8.00024C11 8.55253 11.4477 9.00024 12 9.00024ZM13 14.5002C13 14.7764 13.2239 15.0002 13.5 15.0002H14V16.0002H10V15.0002H10.5C10.7761 15.0002 11 14.7764 11 14.5002V11.0002C11 10.7241 10.7761 10.5002 10.5 10.5002H10V9.50025H12.5C12.7761 9.50025 13 9.7241 13 10.0002V14.5002Z"
    fillRule="evenodd"
  />,
  'InfoFillIcon',
)
